import React from 'react';
import LocalSeoPage from './LocalSeoPage';

const DepannageViry: React.FC = () => (
  <LocalSeoPage
    city="Viry"
    slug="depannage-informatique-viry"
    metaTitle="Dépannage Informatique Viry | Technicien à Domicile"
    metaDescription="Dépannage informatique à Viry (74580). Réparation PC, suppression virus, WiFi. Intervention rapide. Diagnostic gratuit. Appelez !"
    intro="Vous êtes à Viry et votre ordinateur ne fonctionne plus ? Notre technicien informatique intervient rapidement à domicile ou à distance. PC lent, virus, imprimante en panne, Windows bloqué — on règle votre problème simplement, sans jargon, avec un diagnostic 100 % gratuit."
    postalCode="74580"
    nearbyTowns={[
      { name: 'Saint-Julien-en-Genevois', link: '/depannage-informatique-saint-julien-en-genevois' },
      { name: 'Valleiry', link: '/depannage-informatique-valleiry' },
      { name: 'Annemasse', link: '/depannage-informatique-annemasse' },
      { name: 'Vers' },
      { name: 'Feigères' },
      { name: 'Neydens' },
      { name: 'Beaumont' },
      { name: 'Présilly' },
      { name: 'Chênex' },
      { name: 'Andilly' },
      { name: 'Cernex' },
    ]}
    internalLinks={[
      { label: 'Dépannage informatique à Saint-Julien-en-Genevois', href: '/depannage-informatique-saint-julien-en-genevois' },
      { label: 'Assistance PC à Valleiry', href: '/depannage-informatique-valleiry' },
      { label: 'Dépannage informatique à Annemasse', href: '/depannage-informatique-annemasse' },
      { label: 'Dépannage informatique dans le Genevois', href: '/depannage-informatique-genevois' },
    ]}
  />
);

export default DepannageViry;
